import { jsx as _jsx } from "react/jsx-runtime";
const COLOR = {
    starter: "bg-slate-200 text-slate-800",
    pro: "bg-blue-100 text-blue-800",
    enterprise: "bg-emerald-100 text-emerald-800",
};
export function PlanBadge({ tier }) {
    return (_jsx("span", { className: `inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium ${COLOR[tier]}`, children: tier.toUpperCase() }));
}
